export const BRIGHT_GREEN = '#3fc787';
export const SHUTTLE_GREY = '#5a687b';
